module.exports = __webpack_public_path__ + "1.4.15-unryo/img/mesos.3cf38049.png";